/* Filtrous application note view - v2, 2026-09-15 (Adelaide: "redesign
   application note view").

   v2: NOTE CARDS. FI_APPNOTES.cardHTML(id, {exclude: sku}) builds one card per
   note - technique, pages, title, what it tests, the key result, the Filtrous
   products used, and "Read the note" + "PDF". Industry pages mark each slot
   with data-appnote-card="<id>" (snippets/fi-app-notes.liquid; the plain link
   inside is the no-JS fallback); the Documents tab (filtrous-pdp-docs.js)
   calls cardHTML with the page's own SKU excluded, so the row reads "Used
   with". CARD holds the two short lines per note. Key results avoid the
   numbers still under review with Sunny (tirzepatide dose back-calculation,
   GHK-Cu recovery, ethanol results table). Dispatches "fi-appnotes-ready" on
   document once the API exists.

   Clicking an application note used to open the bare PDF. Any link carrying
   data-appnote="<id>" (the industry-page cards from snippets/fi-app-notes.liquid
   and the Documents tab rows from filtrous-pdp-docs.js) now opens a reading
   panel over the page: what the note shows, the headline numbers, the
   Filtrous products it used (live price and stock from catalog-index.json,
   with Add to cart, or Get a quote for OSK kits), the steps, the method
   settings, and the full PDF. The href stays the PDF, so with JavaScript off,
   or with a modified click, the PDF still opens.

   CONTENT RULE: every number and step below is copied from the note itself
   (Sunny's published PDFs, "Application Notes (Sunny)" on Adelaide's Desktop).
   Nothing is rounded or re-derived except where the note states the
   arithmetic. Four molecular notes name retired kit SKUs; the product card
   shows the current kit and says which SKU the note used.

   The panel's URL state is ?note=<id> via history.replaceState - never the
   hash, because the storefront app routes on the hash.

   Loaded by snippets/fi-app-notes.liquid (industry pages, data-index-url on the
   script tag) and sections/filtrous-v3-app.liquid (product pages, reads
   FV3_CONFIG.indexUrl). The PDFs are the theme assets beside this script. */
(function () {
  'use strict';
  if (window.__fiAppNoteView) return;
  window.__fiAppNoteView = true;

  var ME = document.currentScript;
  var ASSET_BASE = ME && ME.src ? ME.src.split('?')[0].replace(/[^\/]*$/, '') : '';
  var INDEX_URL = (ME && ME.getAttribute('data-index-url')) || (window.FV3_CONFIG && window.FV3_CONFIG.indexUrl) || '';

  var NOTES = {
    'uti-multiplex-qpcr': {
      tag: 'qPCR', sample: 'Urine', pages: 12,
      title: 'UTI panel: 23 pathogens and 6 resistance genes',
      lede: 'Urine was concentrated, extracted on the magnetic bead kit and run across 12 UTI mixes and 3 antibiotic resistance mixes. Positive controls amplified for all 23 pathogens and all 6 resistance markers, and the negative controls showed no amplification.',
      stats: [['23', 'pathogen targets amplified in the positive control'], ['6', 'resistance genes amplified in the positive control'], ['28.57 to 31.50', 'RNase P Ct, urine at 100% down to 20%']],
      steps: ['Spin 1.5 mL of urine at 3,500 × g for 5 minutes and keep 50 µL with the pellet.', 'Add 200 µL PBS and 20 µL lytic enzyme mix, then 5 minutes at room temperature.', 'Extract on the Universal Magnetic DNA/RNA Extraction Kit.', 'Run all 12 UTI mixes and 3 ABR mixes, 15 µL mastermix and 5 µL template per well.'],
      method: [['Instrument', 'BioRad CFX-96 with C1000 Touch'], ['Reaction', '20 µL (15 µL mastermix + 5 µL template)'], ['Cycling', '95 °C 2 min, then 40 × (95 °C 10 s, 60 °C 30 s)'], ['Channels', 'FAM, HEX (VIC), Cal Fluor Red 610 (ROX)']],
      products: [['EXK-BD-0096'], ['OSK-UT-M100', 'OSK-UT-0100'], ['OSK-TR-1100', 'OSK-TR-0100']]
    },
    'ecoli-urine-qpcr': {
      tag: 'qPCR', sample: 'Urine', pages: 5,
      title: 'E. coli in urine by qPCR',
      lede: 'Magnetic bead extraction of 1.5 mL of urine, then qPCR on the UTI Plus kit. E. coli was detected in the positive sample and the RNase P control in the negative sample.',
      stats: [['30.12', 'mean Ct, E. coli (n = 3)'], ['33.42', 'mean Ct, RNase P in negative urine'], ['5.840 ng/µL', 'eluate from E. coli positive urine']],
      steps: ['Spin 1.5 mL of urine at 3,500 × g for 5 minutes, leaving about 50 µL.', 'Resuspend in 200 µL PBS with 20 µL lytic enzyme mix, 5 minutes at room temperature.', 'Bind to magnetic beads for 5 minutes, wash once and air-dry 5 to 10 minutes.', 'Elute in 70 µL and run qPCR in triplicate.'],
      method: [['Instrument', 'QuantStudio Real-Time PCR System, 96-well'], ['Sample', '1.5 mL urine, concentrated to about 50 µL'], ['Elution', '70 µL DEPC-treated water'], ['Mode', 'Total nucleic acid, manual with a magnetic rack']],
      products: [['EXK-BD-0096'], ['OSK-UT-M100']]
    },
    'rsv-a-swab-qpcr': {
      tag: 'qPCR', sample: 'Nasopharyngeal swab', pages: 4,
      title: 'RSV-A in nasopharyngeal swabs by qPCR',
      lede: 'Transport medium goes straight into the extraction tube with no pretreatment. RSV-A was detected in the positive swab and the RNase P control in the negative swab.',
      stats: [['29.32', 'mean Ct, RSV-A (n = 3)'], ['26.10', 'mean Ct, RNase P in negative swab'], ['14.101 ng/µL', 'eluate from RSV-A positive swab']],
      steps: ['Add 250 µL of transport medium to the extraction tube and incubate 5 minutes.', 'Add 10 µL magnetic beads and incubate 5 minutes.', 'Wash once, air-dry 5 to 10 minutes and elute in 70 µL.', 'Run qPCR in triplicate with a positive and a no-template control.'],
      method: [['Instrument', 'QuantStudio Real-Time PCR System, 96-well'], ['Sample', '250 µL transport medium'], ['Elution', '70 µL DEPC-treated water'], ['Cycling', '95 °C 2 min, then 40 × (95 °C 10 s, 60 °C 30 s)']],
      products: [['EXK-BD-0096'], ['OSK-RP-1100']]
    },
    'respiratory-panel-rt-qpcr': {
      tag: 'RT-qPCR', sample: 'Nasopharyngeal swab', pages: 6,
      title: 'Respiratory panel: bacterial and viral targets from swabs',
      lede: 'Extracted and unextracted swabs were run side by side on the respiratory panel. For the bacterial target, extraction brought the Ct in about 2 cycles earlier and raised the signal 6.5 times.',
      stats: [['25.04 vs 27.12', 'Ct, Moraxella catarrhalis, extracted vs direct'], ['6.5×', 'fluorescence signal after extraction'], ['20.19 vs 19.85', 'Ct, human metapneumovirus, extracted vs direct']],
      steps: ['Extract on the Universal Magnetic DNA/RNA Extraction Kit per the IFU.', 'For mixes that need reverse transcription, combine 14 µL PCR mix with 1 µL RT enzyme mix.', 'Add 15 µL mastermix and 5 µL template per well.', 'Run all 8 panel mixes in triplicate with positive and negative controls.'],
      method: [['Instrument', 'BioRad CFX-96 with C1000 Touch'], ['Reaction', '20 µL (15 µL mastermix + 5 µL template)'], ['Reverse transcription', '50 °C for 5 minutes'], ['Cycling', '95 °C 2 min, then 40 × (95 °C 10 s, 60 °C 30 s)']],
      products: [['EXK-BD-0096'], ['OSK-RP-1100', 'OSK-RP-0100']]
    },
    'respiratory-viral-rna': {
      tag: 'RT-qPCR', sample: 'Nasopharyngeal swab', pages: 7,
      title: 'Respiratory viral RNA: hMPV and parainfluenza 3',
      lede: 'Two studies: human metapneumovirus extracted vs direct on a 96-well CFX, and the full 8-mix panel on a 384-well QuantStudio 5 at 10 µL reactions, where parainfluenza 3 was detected in Mix 3.',
      stats: [['25', 'Ct, parainfluenza 3 (Mix 3, FAM)'], ['10 µL', 'reactions on a 384-well plate'], ['2,530 vs 2,230', 'RFU, hMPV extracted vs direct']],
      steps: ['Extract on the Universal Magnetic DNA/RNA Extraction Kit per the IFU.', 'Dispense 7.5 µL of each mastermix into a 384-well plate.', 'Add 2.5 µL of extracted template per well, 8 wells per sample.', 'Include a positive and a negative control for each mix.'],
      method: [['Instrument', 'Applied Biosystems QuantStudio 5, 384-well'], ['Reaction', '10 µL (7.5 µL mastermix + 2.5 µL template)'], ['Reverse transcription', '50 °C for 5 minutes'], ['Internal control', 'RNase P, Mix 1, HEX']],
      products: [['EXK-BD-0096'], ['OSK-RP-1100', 'OSK-RP-0100']]
    },
    'bacterial-gdna-qpcr': {
      tag: 'qPCR', sample: 'Swab and urine', pages: 6,
      title: 'Bacterial genomic DNA for respiratory and UTI panels',
      lede: 'Bacterial DNA from a nasopharyngeal swab and from urine spiked with Klebsiella pneumoniae (ATCC BAA-1898), extracted and unextracted. Extraction brought the KPC resistance gene in 7 cycles earlier.',
      stats: [['25 to 18', 'Ct, KPC resistance gene, direct to extracted'], ['21 to 18', 'Ct, Klebsiella pneumoniae, direct to extracted'], ['6.5×', 'signal gain, Moraxella catarrhalis from swab']],
      steps: ['Spin 1.5 mL of urine at 3,500 × g for 5 minutes and keep 50 µL with the pellet.', 'Add 200 µL PBS and 20 µL lytic enzyme mix, then 5 minutes at room temperature.', 'Extract swab and urine samples on the magnetic bead kit.', 'Run 12 UTI and 3 ABR mixes for urine, 8 respiratory mixes for the swab.'],
      method: [['Instrument', 'BioRad CFX-96 with C1000 Touch'], ['Reference material', 'Klebsiella pneumoniae ATCC BAA-1898'], ['Reaction', '20 µL (15 µL mastermix + 5 µL template)'], ['Cycling', '95 °C 2 min, then 40 × (95 °C 10 s, 60 °C 30 s)']],
      products: [['EXK-BD-0096'], ['OSK-RP-1100', 'OSK-RP-0100'], ['OSK-UT-M100', 'OSK-UT-0100'], ['OSK-TR-1100', 'OSK-TR-0100']]
    },
    'whole-blood-dna-rna': {
      tag: 'qPCR', sample: 'Whole blood', pages: 3,
      title: 'DNA/RNA recovery from whole blood',
      lede: '50 µL of whole blood, a 30-minute room-temperature pretreatment, then magnetic bead extraction. The RNase P control amplified at a mean Ct of 26.03.',
      stats: [['26.03', 'mean Ct, RNase P (n = 3)'], ['50 µL', 'whole blood input'], ['13.289 ng/µL', 'eluate concentration']],
      steps: ['Mix 50 µL blood with 50 µL lytic buffer and 8 µL Proteinase K, then vortex.', 'Incubate 30 minutes at room temperature.', 'Add the lysate to the extraction tube, then 10 µL magnetic beads for 5 minutes.', 'Wash once, air-dry 5 to 10 minutes and elute in 70 µL.'],
      method: [['Instrument', 'QuantStudio Real-Time PCR System, 96-well'], ['Pretreatment', 'Lytic buffer + Proteinase K, 30 min at room temperature'], ['Elution', '70 µL DEPC-treated water'], ['Mode', 'Total nucleic acid, manual with a magnetic rack']],
      products: [['EXK-BD-0096'], ['OSK-WD-M100']]
    },
    'ffpe-dna-rna': {
      tag: 'qPCR', sample: 'FFPE tissue', pages: 4,
      title: 'DNA/RNA recovery from FFPE tissue',
      lede: 'One buffer handles wax, formalin cross-links and lysis in a single tube, with no separate deparaffinization reagents. About 5 mg of tissue gave 911.9 ng of nucleic acid.',
      stats: [['911.9 ng', 'total yield from about 5 mg of tissue'], ['1.75', 'A260/A280'], ['28.78', 'mean Ct, RNase P (SD 0.11)']],
      steps: ['Trim excess wax and place about 5 mg of tissue in 200 µL Buffer NLY with 20 µL Proteinase K.', 'Shake at 50 °C for 3 hours.', 'Spin at 13,000 × g for 5 minutes and keep the cleared supernatant.', 'Extract 200 µL on the magnetic bead kit and elute in 70 µL.'],
      method: [['Instrument', 'QuantStudio Real-Time PCR System, 96-well'], ['Pretreatment', 'Buffer NLY + Proteinase K, 50 °C for 3 hours'], ['Elution', '70 µL DEPC-treated water'], ['Mode', 'Total nucleic acid, manual with a magnetic rack']],
      products: [['EXK-BD-0096'], ['OSK-WD-M100']]
    },
    'nail-fungus-qpcr': {
      tag: 'qPCR', sample: 'Nail clipping', pages: 5,
      title: 'Nail fungus (E. floccosum) in tough-to-lyse samples',
      lede: 'A 15-minute bead-beating pretreatment disrupts the keratinized nail before magnetic bead extraction. Epidermophyton floccosum was detected in a positive clipping, and the no-template control returned undetermined.',
      stats: [['33.43', 'mean Ct, E. floccosum (n = 3)'], ['15 min', 'bead-beating pretreatment'], ['18.38', 'positive control Ct']],
      steps: ['Put about 0.5 cm of dry nail in a tube with 250 mg of 0.5 mm zirconia beads and 800 µL Filtrous Transport Medium.', 'Bead-beat for 15 minutes, then spin at 3,600 × g for 2 minutes.', 'Add 250 µL of the cleared supernatant to the extraction tube and extract.', 'Elute in 70 µL and run qPCR in triplicate.'],
      method: [['Instrument', 'QuantStudio Real-Time PCR System, 96-well'], ['Sample', 'About 0.5 cm dry nail clipping'], ['Elution', '70 µL DEPC-treated water'], ['Mode', 'Total nucleic acid, manual with a magnetic rack']],
      products: [['EXK-BD-0096'], ['OSK-NF-1100']]
    },
    'cannabis-pesticides-lcmsms': {
      tag: 'LC-MS/MS', sample: 'Cannabis flower', pages: 8,
      title: 'Cannabis pesticide residues by LC-MS/MS',
      lede: 'A scheduled MRM screen of California-regulated pesticides on a SCIEX Triple Quad 6500+ with a 10-minute run. Paclobutrazol was found at about 22 ppb in a flower sample.',
      stats: [['~22 ppb', 'paclobutrazol found in flower'], ['25 to 200 ppb', 'calibration range'], ['10 min', 'total run time']],
      steps: ['Weigh 500 mg of flower into a 50 mL conical tube.', 'Add 10 mL of acetonitrile and extract.', 'Dilute the extract 10 times in acetonitrile.', 'Filter through a 0.22 µm PTFE syringe filter into a vial and inject 3 µL.'],
      method: [['LC', 'Shimadzu Prominence'], ['Column', 'Phenomenex Kinetex 2.6 µm Phenyl-Hexyl, 50 × 2.1 mm, 40 °C'], ['Mobile phase', 'A: 10 mM ammonium formate in LC-MS water. B: 0.1% formic acid in LC-MS acetonitrile'], ['MS', 'SCIEX Triple Quad 6500+, ESI positive and negative']],
      products: [['MBP-01-2404'], ['MBP-03-2404'], ['SFN-BR-1025'], ['CCF-10-4500']]
    },
    'cannabinoid-potency-hplc': {
      tag: 'HPLC', sample: 'Cannabis flower trim', pages: 6,
      title: 'Cannabinoid potency: 15+ cannabinoids by HPLC',
      lede: 'One isocratic HPLC-PDA method separates 15 cannabinoids, with Δ9-THC and Δ8-THC as separate peaks.',
      stats: [['15', 'cannabinoids calibrated, 10 to 100 ppm'], ['99.97%+', 'R² for every compound'], ['6.97 / 7.40 min', 'Δ9-THC and Δ8-THC retention']],
      steps: ['Weigh 7 g of flower trim.', 'Suspend in 50 mL methanol and 20 mL acetonitrile.', 'Shake for 10 minutes at room temperature.', 'Filter 1.5 mL of the supernatant through a 0.22 µm syringe filter and run on HPLC-PDA.'],
      method: [['Instrument', 'Shimadzu Prominence-i LC-2030C 3D Plus'], ['Column', 'Kinetex 2.6 µm C18 100 Å, 150 × 4.6 mm, 40 °C'], ['Mobile phase', 'Isocratic: 20 mM ammonium formate with 0.1% formic acid in water, and acetonitrile'], ['Detection', 'PDA at 220, 228 and 240 nm, 1.0 mL/min']],
      products: [['SFN-AR-1025']]
    },
    'tirzepatide-purity-hplc': {
      tag: 'HPLC', sample: 'Tirzepatide standard', pages: 4,
      title: 'Tirzepatide purity by HPLC-PDA',
      lede: 'One 15-minute gradient gives identity, purity and content per dose. The reference standard read 94.18% purity by area, and a worked example shows how to back-calculate content per dose against a label claim.',
      stats: [['94.18%', 'HPLC purity by area at 220 nm'], ['5.82%', 'one resolved impurity peak, at 6.93 min'], ['9.61 min', 'tirzepatide retention time']],
      steps: ['Reconstitute in HPLC-grade water at 10 mg/mL. Do not use bacteriostatic water.', 'Vortex briefly to dissolve.', 'Filter through a 0.22 µm × 13 mm H-PTFE syringe filter into a vial.', 'Inject 1 µL.'],
      method: [['Instrument', 'Prominence LC-2030C 3D Plus'], ['Column', 'Phenomenex Luna Omega 3 µm Polar C18, 150 × 4.6 mm, 35 °C'], ['Mobile phase', '0.1% formic acid in HPLC water and acetonitrile, 10 to 90% B'], ['Detection', 'PDA at 220 nm, 1.0 mL/min']],
      tip: 'Bacteriostatic water contains benzyl alcohol, which elutes at about 6.3 minutes and interferes with purity integration.',
      products: [['MBP-01-1404'], ['MBP-03-1404'], ['SFN-GR-1013']]
    },
    'tirzepatide-mass-lcms': {
      tag: 'LC-MS', sample: 'Injectable solution', pages: 4,
      title: 'Tirzepatide mass confirmation by LC-MS',
      lede: 'Q1 full-scan LC-MS on a SCIEX 6500 identifies tirzepatide from its co-eluting 4+ and 5+ charge states, whose ratio matches the expected 5/4 to within 0.2%.',
      stats: [['1201.9 / 963.4', 'm/z, [M+4H]⁴⁺ and [M+5H]⁵⁺'], ['0.2%', 'charge-state ratio vs expected 5/4'], ['~7.5 min', 'retention time']],
      steps: ['Dilute the injectable 100 times in LC-MS grade water.', 'Filter through a 0.22 µm × 13 mm H-PTFE syringe filter into a vial.', 'Inject 2 µL.'],
      method: [['LC', 'Shimadzu Prominence, 0.5 mL/min'], ['Column', 'Phenomenex Luna Omega 3 µm Polar C18, 100 × 4.6 mm, 40 °C'], ['Mobile phase', '0.1% formic acid in LC-MS water and acetonitrile, 10 to 90% B'], ['MS', 'SCIEX 6500, ESI positive, Q1 scan 300 to 2000 m/z']],
      tip: 'The absolute mass from the 5+ ion back-calculates to about 4812 Da, at the edge of the ±1 Da criterion. The note recommends a high-mass recalibration.',
      products: [['MBP-01-2404'], ['MBP-03-2404'], ['SFN-GR-1013']]
    },
    'ghk-cu-cream-hplc': {
      tag: 'HPLC', sample: 'Cosmetic cream', pages: 4,
      title: 'GHK-Cu in cosmetic cream by HPLC-PDA',
      lede: 'A commercial 4% GHK-Cu cream was extracted with water and acetonitrile, filtered and run on HPLC-PDA. With the declared preservative excluded, GHK-Cu read 95.93% purity by area.',
      stats: [['95.93%', 'purity by area, declared excipient excluded'], ['1.61 min', 'GHK-Cu retention time'], ['1 µL per mg', 'diluent to cream']],
      steps: ['Weigh 372.6 mg of cream into a low-bind 2 mL tube.', 'Add 372.6 µL of 50:50 HPLC-grade water and acetonitrile.', 'Vortex for 1 minute.', 'Filter through a 0.22 µm × 13 mm H-PTFE syringe filter into a vial and inject 5 µL.'],
      method: [['Instrument', 'Prominence LC-2030C 3D Plus'], ['Column', 'Phenomenex Luna Omega 3 µm Polar C18, 150 × 4.6 mm, 35 °C'], ['Mobile phase', '0.1% formic acid in HPLC water and acetonitrile, 10 to 90% B'], ['Detection', 'PDA at 220 nm, 1.0 mL/min']],
      products: [['MBP-01-1404'], ['MBP-03-1404'], ['SFN-GR-1013']]
    },
    'ghk-cream-mass-lcms': {
      tag: 'LC-MS', sample: 'Cosmetic cream', pages: 4,
      title: 'GHK mass confirmation in cosmetic cream by LC-MS',
      lede: 'Q1 full-scan LC-MS confirms GHK identity in a 4% GHK-Cu cream from the protonated ion at m/z 342.1, within ±1 Da of its theoretical value.',
      stats: [['342.1', 'm/z, GHK [M+H]⁺ base peak'], ['+0.7 Da', 'from theoretical 341.4'], ['~2.1 min', 'retention time']],
      steps: ['Weigh 372.6 mg of cream into a low-bind 2 mL tube.', 'Add 372.6 µL of 50:50 LC-MS grade water and acetonitrile, then vortex 1 minute.', 'Filter through a 0.22 µm × 13 mm H-PTFE syringe filter into a vial.', 'Inject 2 µL.'],
      method: [['LC', 'Shimadzu Prominence, 0.5 mL/min'], ['Column', 'Phenomenex Luna Omega 3 µm Polar C18, 100 × 4.6 mm, 40 °C'], ['Mobile phase', '0.1% formic acid in LC-MS water and acetonitrile, 10 to 90% B'], ['MS', 'SCIEX 6500, ESI positive, Q1 scan 300 to 1000 m/z']],
      products: [['MBP-01-2404'], ['MBP-03-2404'], ['SFN-GR-1013']]
    },
    'ethanol-fermentation-hplc': {
      tag: 'HPLC', sample: 'Fermentation', pages: 5,
      title: 'Ethanol fermentation: sugars, alcohols and acids by HPLC-RID',
      lede: 'An isocratic HPLC-RID method for dextrins, maltotriose, maltose, glucose, lactic acid, glycerol, acetic acid and ethanol on one column.',
      stats: [['8', 'analytes calibrated'], ['0.9994+', 'R² for every analyte'], ['11.26 min', 'ethanol retention time']],
      steps: ['Gravity-filter the sample through 25 µm filter paper.', 'Filter 1.5 mL through a 0.22 µm triple-layer PES syringe filter.', 'Dilute 1:99.', 'Run on HPLC-RID.'],
      method: [['Instrument', 'Shimadzu HPLC with RID-10A'], ['Column', 'Rezex RHM-Monosaccharide H+ (8%), 150 × 7.8 mm, 60 °C'], ['Mobile phase', '0.005 N sulfuric acid, isocratic, 0.6 mL/min'], ['Injection', '5 µL']],
      tip: 'Dextrin DP4+ and maltotriose overlap on this method, so they are integrated where the peaks split.',
      products: [['SFN-CQ-1030'], ['6150-1250']]
    }
  };

  /* Card lines: [what it tests, key result]. Copied from the notes. */
  var CARD = {
    'cannabis-pesticides-lcmsms': ['Cannabis flower, California pesticide list', 'Paclobutrazol found at about 22 ppb'],
    'cannabinoid-potency-hplc': ['Flower trim, 15 cannabinoids', 'Δ9-THC and Δ8-THC separated, at 6.97 and 7.40 min'],
    'tirzepatide-purity-hplc': ['Tirzepatide reference standard', '94.18% purity by area at 220 nm'],
    'tirzepatide-mass-lcms': ['Tirzepatide injectable solution', '4+ and 5+ ions at m/z 1201.9 and 963.4'],
    'ghk-cu-cream-hplc': ['Cosmetic cream with a 4% GHK-Cu label', '95.93% purity by area, declared excipient excluded'],
    'ghk-cream-mass-lcms': ['Cosmetic cream', 'GHK [M+H]⁺ base peak at m/z 342.1'],
    'uti-multiplex-qpcr': ['Urine, 12 UTI mixes and 3 resistance mixes', '23 pathogens and 6 resistance genes amplified in the positive control'],
    'ecoli-urine-qpcr': ['1.5 mL of urine', 'E. coli detected, mean Ct 30.12 (n = 3)'],
    'rsv-a-swab-qpcr': ['Nasopharyngeal swab, no pretreatment', 'RSV-A detected, mean Ct 29.32 (n = 3)'],
    'respiratory-panel-rt-qpcr': ['Nasopharyngeal swab, extracted and direct', 'Moraxella Ct 25.04 extracted vs 27.12 direct'],
    'respiratory-viral-rna': ['Nasopharyngeal swab, full 8-mix panel', 'Parainfluenza 3 detected in Mix 3, Ct 25'],
    'bacterial-gdna-qpcr': ['Nasopharyngeal swab and contrived urine', 'KPC gene Ct 25 direct, 18 extracted'],
    'whole-blood-dna-rna': ['50 µL of whole blood', 'RNase P mean Ct 26.03 (n = 3)'],
    'ffpe-dna-rna': ['About 5 mg of FFPE tissue', '911.9 ng total yield, A260/A280 1.75'],
    'nail-fungus-qpcr': ['Nail clipping, 15 min bead-beating', 'E. floccosum detected, mean Ct 33.43 (n = 3)'],
    'ethanol-fermentation-hplc': ['Fermentation samples: sugars, alcohols and acids', 'Ethanol at 11.26 min, R² 0.9994 or better for every analyte']
  };

  /* Short product names for the card's "Used" line (full titles are in catalog-index). */
  var SHORT = {
    'EXK-BD-0096': 'Magnetic DNA/RNA extraction kit',
    'OSK-UT-M100': 'UTI Plus qPCR kit',
    'OSK-TR-1100': 'Antibiotic resistance qPCR kit',
    'OSK-RP-1100': 'Respiratory qPCR kit',
    'OSK-NF-1100': 'Nail fungal qPCR kit',
    'OSK-WD-M100': 'Wound qPCR kit',
    'MBP-01-2404': 'LC-MS grade acetonitrile',
    'MBP-03-2404': 'LC-MS grade water',
    'MBP-01-1404': 'HPLC grade acetonitrile',
    'MBP-03-1404': 'HPLC grade water',
    'SFN-GR-1013': 'H-PTFE syringe filter, 13 mm',
    'SFN-BR-1025': 'PTFE syringe filter, 25 mm',
    'SFN-AR-1025': 'Nylon syringe filter, 25 mm',
    'SFN-CQ-1030': 'PES syringe filter, 32 mm',
    'CCF-10-4500': '50 mL conical tubes',
    '6150-1250': 'Grade 615 filter paper'
  };

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function pdfUrl(id) { return ASSET_BASE + 'fi-appnote-' + id + '.pdf'; }
  function isQuote(sku) { return String(sku || '').toUpperCase().indexOf('OSK') !== -1; }
  function money(v) { var n = parseFloat(v); return isFinite(n) ? '$' + n.toFixed(2) : ''; }

  var indexPromise = null;
  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = INDEX_URL
      ? fetch(INDEX_URL, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var by = {};
            ((d && d.products) || []).forEach(function (p) { if (p && p.sku) by[String(p.sku).toUpperCase()] = p; });
            return by;
          }).catch(function () { return {}; })
      : Promise.resolve({});
    return indexPromise;
  }

  /* ---------- styles ---------- */
  function css() {
    if (document.getElementById('fan-css')) return;
    var st = document.createElement('style');
    st.id = 'fan-css';
    st.textContent = [
      '.fan-scrim{position:fixed;inset:0;z-index:2000;background:rgba(8,47,75,.45);display:flex;align-items:flex-start;justify-content:center;padding:4vh 16px;box-sizing:border-box;font-family:"DM Sans",system-ui,-apple-system,"Segoe UI",sans-serif;color:#082F4B}',
      '.fan-scrim[hidden]{display:none}',
      '.fan-sheet{position:relative;width:100%;max-width:920px;max-height:92vh;overflow:auto;overscroll-behavior:contain;background:#fff;border-radius:20px;box-shadow:0 24px 64px rgba(8,47,75,.28)}',
      '.fan-bar{position:sticky;top:0;z-index:2;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 16px 12px 28px;background:rgba(255,255,255,.96);border-bottom:1px solid rgba(8,47,75,.1)}',
      '.fan-bar__label{font-size:13px;font-weight:700;color:#0B6B59}',
      '.fan-bar__actions{display:flex;align-items:center;gap:8px}',
      '.fan-close{display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;border:0;border-radius:999px;background:transparent;color:#082F4B;cursor:pointer}',
      '.fan-close:hover{background:#F2F6FE}',
      '.fan-body{padding:28px 40px 40px}',
      '.fan-meta{display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin:0 0 12px;font-size:13px;color:#4F5D6E}',
      '.fan-tag{display:inline-flex;align-items:center;min-height:24px;padding:0 10px;border-radius:999px;background:#E6F4F0;color:#0B6B59;font-weight:700}',
      '.fan-meta .fan-dot{width:3px;height:3px;border-radius:50%;background:#8593A3}',
      '.fan-title{margin:0 0 12px;font-size:34px;font-weight:700;line-height:1.15;letter-spacing:-.02em;color:#082F4B}',
      '.fan-lede{margin:0 0 24px;max-width:68ch;font-size:17px;line-height:1.55;color:#33485c}',
      '.fan-stats{list-style:none;margin:0 0 32px;padding:0;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}',
      '.fan-stats li{padding:16px 18px;background:#F2F6FE;border-radius:14px}',
      '.fan-stats b{display:block;font-size:22px;font-weight:700;line-height:1.2;color:#082F4B}',
      '.fan-stats span{display:block;margin-top:4px;font-size:13px;line-height:1.4;color:#4F5D6E}',
      '.fan-h3{margin:0 0 12px;font-size:17px;font-weight:700;color:#082F4B}',
      '.fan-section{margin:0 0 32px}',
      '.fan-products{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(auto-fill,minmax(250px,1fr));gap:12px}',
      '.fan-prod{display:flex;gap:12px;align-items:flex-start;height:100%;box-sizing:border-box;padding:14px;border:1px solid rgba(8,47,75,.12);border-radius:14px;background:#fff}',
      '.fan-prod__img{flex:none;width:64px;height:64px;border-radius:10px;background:#fff;object-fit:contain}',
      '.fan-prod__main{display:flex;flex-direction:column;gap:4px;min-width:0;flex:1}',
      '.fan-prod__t{font-size:15px;font-weight:600;line-height:1.3;color:#082F4B;text-decoration:none}',
      '.fan-prod__t:hover{text-decoration:underline;text-underline-offset:2px}',
      '.fan-prod__sku,.fan-prod__was{font-size:13px;color:#4F5D6E}',
      '.fan-prod__row{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;margin-top:6px}',
      '.fan-prod__price{font-size:15px;font-weight:700;color:#082F4B}',
      '.fan-prod__msg{font-size:13px;font-weight:600;color:#0B6B59}',
      '.fan-prod__msg.is-err{color:#B42318}',
      '.fan-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;min-height:44px;padding:0 20px;box-sizing:border-box;border:0;border-radius:980px;background:#082F4B;color:#fff;font:inherit;font-size:15px;font-weight:600;line-height:1;text-decoration:none;cursor:pointer;white-space:nowrap}',
      '.fan-btn:hover{background:#124E79}',
      '.fan-btn:disabled{background:#8593A3;cursor:default}',
      '.fan-btn--ghost{background:transparent;color:#082F4B;box-shadow:inset 0 0 0 1.5px rgba(8,47,75,.25)}',
      '.fan-btn--ghost:hover{background:rgba(8,47,75,.06)}',
      '.fan-btn--mint{background:linear-gradient(135deg,#21D6B3,#CBFFF6);color:#082F4B}',
      '.fan-btn--mint:hover{background:linear-gradient(135deg,#1CC4A4,#B8F5EA)}',
      '.fan-btn--sm{min-height:44px;padding:0 16px;font-size:15px}',
      '.fan-cols{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,1fr);gap:32px;margin:0 0 32px}',
      '.fan-steps{margin:0;padding:0;list-style:none;counter-reset:fan}',
      '.fan-steps li{position:relative;padding:0 0 14px 40px;font-size:15px;line-height:1.5;color:#33485c;counter-increment:fan}',
      '.fan-steps li::before{content:counter(fan);position:absolute;left:0;top:-2px;width:28px;height:28px;border-radius:999px;background:linear-gradient(135deg,#21D6B3,#CBFFF6);color:#082F4B;font-size:13px;font-weight:800;display:flex;align-items:center;justify-content:center}',
      '.fan-dl{margin:0;display:grid;grid-template-columns:max-content minmax(0,1fr);gap:10px 16px;font-size:15px;line-height:1.45}',
      '.fan-dl dt{font-weight:600;color:#082F4B}',
      '.fan-dl dd{margin:0;color:#33485c}',
      '.fan-tip{margin:0 0 32px;padding:14px 18px;border-left:3px solid #21D6B3;background:#F3FBF8;border-radius:0 12px 12px 0;font-size:15px;line-height:1.5;color:#33485c}',
      '.fan-cta{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:22px 24px;border:1px solid rgba(8,47,75,.12);border-radius:16px}',
      '.fan-cta p{margin:4px 0 0;font-size:15px;color:#4F5D6E}',
      '.fan-card{display:flex;flex-direction:column;gap:12px;height:100%;box-sizing:border-box;margin:0;padding:20px;background:#fff;border:1px solid rgba(8,47,75,.12);border-radius:14px;font-family:inherit;color:#082F4B;text-align:left}',
      '.fan-card .fan-card__meta{display:flex;align-items:center;gap:8px;margin:0;font-size:13px;line-height:1.3;color:#4F5D6E}',
      '.fan-card .fan-card__t{margin:0;font-size:17px;font-weight:700;line-height:1.3;letter-spacing:0;color:#082F4B}',
      '.fan-card .fan-card__facts{display:grid;gap:8px;margin:0}',
      '.fan-card .fan-card__facts div{display:grid;grid-template-columns:84px minmax(0,1fr);gap:12px}',
      '.fan-card .fan-card__facts dt{margin:0;font-size:13px;font-weight:600;line-height:1.45;color:#4F5D6E}',
      '.fan-card .fan-card__facts dd{margin:0;font-size:14px;line-height:1.45;color:#082F4B}',
      '.fan-card .fan-card__facts a{color:#082F4B;text-decoration:underline;text-decoration-color:rgba(8,47,75,.35);text-underline-offset:2px}',
      '.fan-card .fan-card__facts a:hover{color:#0B6B59;text-decoration-color:currentColor}',
      '.fan-card .fan-card__actions{display:flex;flex-wrap:wrap;gap:8px;margin-top:auto;padding-top:4px}',
      '.fan-card .fan-btn{color:#fff;text-decoration:none}',
      '.fan-card .fan-btn--ghost{color:#082F4B}',
      '.fan-card a:focus-visible{outline:3px solid #21D6B3;outline-offset:2px}',
      '.fan-close:focus-visible,.fan-btn:focus-visible,.fan-prod__t:focus-visible{outline:3px solid #21D6B3;outline-offset:2px}',
      '.fan-vh{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
      'html.fan-open,html.fan-open body{overflow:hidden}',
      /* The page's "Build your bench" section, moved in under "Read the full note"
         (2026-09-16, Adelaide). Laid out in one column - the sheet is 920px wide. */
      /* The builder's own CSS reads --fi-* , which the industry section declares on
         .fi-industry-landing. The panel hangs off <body>, so the moved node loses them:
         solid .fi-btn came out transparent with white text. Redeclare them here. */
      '.fan-sheet{--fi-navy:#082F4B;--fi-teal:#0B6B59;--fi-grey:#4F5D6E;--fi-line:rgba(8,47,75,.1)}',
      '.fan-bench{margin-top:32px}',
      '.fan-bench:empty{display:none}',
      '.fan-sheet .fi-builder{margin:0;border-radius:14px}',
      '.fan-sheet .fi-b{grid-template-columns:minmax(0,1fr)}',
      '.fan-sheet .fi-b-steps{display:flex;gap:4px;overflow-x:auto;border-right:0;border-bottom:1px solid rgba(8,47,75,.1)}',
      '.fan-sheet .fi-b-steps li{flex:none}',
      '.fan-sheet .fi-b-body{border-right:0}',
      '.fan-sheet .fi-b-opts{max-height:340px}',
      '.fan-sheet .fi-b-sum{position:static;max-height:none;border-top:1px solid rgba(8,47,75,.1)}',
      '@media (prefers-reduced-motion:no-preference){.fan-sheet{animation:fanIn .22s ease-out}@keyframes fanIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}}',
      '@media (max-width:760px){.fan-scrim{padding:0}.fan-sheet{max-height:100vh;height:100%;border-radius:0}.fan-bar{padding:8px 8px 8px 16px}.fan-bar .fan-btn--ghost{display:none}.fan-body{padding:20px 16px 32px}.fan-title{font-size:28px}.fan-stats{grid-template-columns:minmax(0,1fr)}.fan-cols{grid-template-columns:minmax(0,1fr);gap:24px}.fan-cta{flex-direction:column;align-items:flex-start}}'
    ].join('');
    document.head.appendChild(st);
  }

  /* ---------- markup ---------- */
  var ICON_X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_DL = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';

  function productsHTML(list, by) {
    var cards = list.map(function (pair) {
      var sku = pair[0], was = pair[1], p = by[String(sku).toUpperCase()];
      if (!p || !p.handle) return '';
      var href = '/products/' + p.handle;
      var action;
      if (isQuote(sku)) {
        action = '<a class="fan-btn fan-btn--sm fan-btn--mint" href="' + esc(href) + '">Get a quote</a>';
      } else if (p.available && p.vid) {
        action = '<button type="button" class="fan-btn fan-btn--sm" data-fan-add="' + esc(p.vid) + '">Add to cart</button>';
      } else {
        action = '<a class="fan-btn fan-btn--sm fan-btn--ghost" href="' + esc(href) + '">View product</a>';
      }
      return '<li class="fan-prod">' +
        (p.image ? '<img class="fan-prod__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="64">' : '') +
        '<div class="fan-prod__main">' +
          '<a class="fan-prod__t" href="' + esc(href) + '">' + esc(p.title) + '</a>' +
          '<span class="fan-prod__sku">' + esc(p.sku) + '</span>' +
          (was ? '<span class="fan-prod__was">The note uses ' + esc(was) + ', the earlier part number for this kit.</span>' : '') +
          '<div class="fan-prod__row"><span class="fan-prod__price">' + (isQuote(sku) ? 'Call for quote' : esc(money(p.price))) + '</span>' + action + '</div>' +
          '<span class="fan-prod__msg" role="status" aria-live="polite"></span>' +
        '</div></li>';
    }).join('');
    return cards;
  }

  function noteHTML(id, n, by) {
    var pdf = pdfUrl(id);
    var prods = productsHTML(n.products || [], by);
    return '<div class="fan-bar">' +
        '<span class="fan-bar__label">Application Note</span>' +
        '<div class="fan-bar__actions">' +
          '<a class="fan-btn fan-btn--ghost" href="' + esc(pdf) + '" target="_blank" rel="noopener">' + ICON_DL + 'PDF<span class="fan-vh"> (opens in a new tab)</span></a>' +
          '<button type="button" class="fan-close" data-fan-close aria-label="Close application note">' + ICON_X + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="fan-body">' +
        '<p class="fan-meta"><span class="fan-tag">' + esc(n.tag) + '</span>' + esc(n.sample) + '<span class="fan-dot" aria-hidden="true"></span>' + n.pages + ' pages</p>' +
        '<h2 class="fan-title" id="fan-title">' + esc(n.title) + '</h2>' +
        '<p class="fan-lede">' + esc(n.lede) + '</p>' +
        '<ul class="fan-stats" aria-label="Key results">' + n.stats.map(function (s) {
          return '<li><b>' + esc(s[0]) + '</b><span>' + esc(s[1]) + '</span></li>';
        }).join('') + '</ul>' +
        '<div class="fan-cols">' +
          '<section aria-labelledby="fan-steps-h"><h3 class="fan-h3" id="fan-steps-h">How it is run</h3><ol class="fan-steps">' +
            n.steps.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ol></section>' +
          '<section aria-labelledby="fan-method-h"><h3 class="fan-h3" id="fan-method-h">Method</h3><dl class="fan-dl">' +
            n.method.map(function (m) { return '<dt>' + esc(m[0]) + '</dt><dd>' + esc(m[1]) + '</dd>'; }).join('') + '</dl></section>' +
        '</div>' +
        (n.tip ? '<p class="fan-tip">' + esc(n.tip) + '</p>' : '') +
        (prods ? '<section class="fan-section" aria-labelledby="fan-prod-h"><h3 class="fan-h3" id="fan-prod-h">Filtrous products used</h3><ul class="fan-products">' + prods + '</ul></section>' : '') +
        '<div class="fan-cta"><div><h3 class="fan-h3" style="margin:0">Read the full note</h3><p>Every condition, figure and data table.</p></div>' +
          '<a class="fan-btn" href="' + esc(pdf) + '" target="_blank" rel="noopener">' + ICON_DL + 'Download PDF, ' + n.pages + ' pages<span class="fan-vh"> (opens in a new tab)</span></a></div>' +
        '<div class="fan-bench" data-fan-bench></div>' +
      '</div>';
  }

  /* ---------- cards ---------- */
  var indexBy = null;   // catalog-index by SKU once loaded, so product names link to their pages

  function linkNames(by) {
    [].slice.call(document.querySelectorAll('.fan-card [data-fan-sku]')).forEach(function (s) {
      var p = by[String(s.getAttribute('data-fan-sku')).toUpperCase()];
      if (!p || !p.handle) return;
      var a = document.createElement('a');
      a.href = '/products/' + p.handle;
      a.textContent = s.textContent;
      s.parentNode.replaceChild(a, s);
    });
  }

  function cardHTML(id, opts) {
    var n = NOTES[id], c = CARD[id];
    if (!n || !c) return '';
    opts = opts || {};
    css();
    var ex = String(opts.exclude || '').toUpperCase();
    var skus = (n.products || []).map(function (pair) { return String(pair[0]).toUpperCase(); });
    var excluded = ex && skus.indexOf(ex) !== -1;
    var pending = false;
    var used = skus.filter(function (sku) { return sku !== ex && SHORT[sku]; }).map(function (sku) {
      var p = indexBy && indexBy[sku];
      if (p && p.handle) return '<a href="/products/' + esc(p.handle) + '">' + esc(SHORT[sku]) + '</a>';
      pending = true;
      return '<span data-fan-sku="' + esc(sku) + '">' + esc(SHORT[sku]) + '</span>';
    }).join(', ');
    if (pending && !indexBy) loadIndex().then(function (by) { indexBy = by; linkNames(by); });
    var pdf = pdfUrl(id);
    return '<article class="fan-card">' +
      '<p class="fan-card__meta"><span class="fan-tag">' + esc(n.tag) + '</span>' + n.pages + ' pages</p>' +
      '<h3 class="fan-card__t">' + esc(n.title) + '</h3>' +
      '<dl class="fan-card__facts">' +
        '<div><dt>Tests</dt><dd>' + esc(c[0]) + '</dd></div>' +
        '<div><dt>Key result</dt><dd>' + esc(c[1]) + '</dd></div>' +
        (used ? '<div><dt>' + (excluded ? 'Used with' : 'Used') + '</dt><dd>' + used + '</dd></div>' : '') +
      '</dl>' +
      '<div class="fan-card__actions">' +
        '<a class="fan-btn fan-btn--sm" href="' + esc(pdf) + '" data-appnote="' + esc(id) + '">Read the note<span class="fan-vh">: ' + esc(n.title) + '</span></a>' +
        '<a class="fan-btn fan-btn--sm fan-btn--ghost" href="' + esc(pdf) + '" target="_blank" rel="noopener">' + ICON_DL + 'PDF<span class="fan-vh"> of ' + esc(n.title) + ', opens in a new tab</span></a>' +
      '</div>' +
    '</article>';
  }

  /* Industry pages: swap each data-appnote-card slot's fallback link for the card. */
  function enhanceCards() {
    [].slice.call(document.querySelectorAll('[data-appnote-card]')).forEach(function (slot) {
      var html = cardHTML(slot.getAttribute('data-appnote-card'), {});
      if (!html) return;
      slot.innerHTML = html;
      slot.removeAttribute('data-appnote-card');
    });
  }

  /* ---------- dialog ---------- */
  var scrim = null, sheet = null, lastFocus = null, openId = null;

  /* ---------- Build your bench ----------
     The industry page's builder section is MOVED into the panel, under "Read the
     full note" (2026-09-16, Adelaide), and put back where it was on close, so the
     page keeps one builder with its live wiring intact. Pages without one (the
     Documents tab on a product page) just drop the empty slot. */
  var benchHome = null;

  function mountBench() {
    var slot = sheet && sheet.querySelector('[data-fan-bench]');
    if (!slot) return;
    var bench = document.querySelector('[data-fi-builder]');
    if (!bench) { if (slot.parentNode) slot.parentNode.removeChild(slot); return; }
    if (!benchHome) benchHome = { parent: bench.parentNode, next: bench.nextSibling };
    slot.appendChild(bench);
  }

  function unmountBench() {
    if (!benchHome) return;
    var bench = document.querySelector('[data-fi-builder]');
    if (bench) benchHome.parent.insertBefore(bench, benchHome.next);
    benchHome = null;
  }

  function ensureShell() {
    if (scrim) return;
    css();
    scrim = document.createElement('div');
    scrim.className = 'fan-scrim';
    scrim.hidden = true;
    sheet = document.createElement('div');
    sheet.className = 'fan-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'fan-title');
    scrim.appendChild(sheet);
    document.body.appendChild(scrim);

    scrim.addEventListener('click', function (e) {
      if (e.target === scrim || (e.target.closest && e.target.closest('[data-fan-close]'))) close();
    });
    sheet.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-fan-add]');
      if (b) add(b);
      var v = e.target.closest && e.target.closest('[data-fan-cart]');
      if (v) { e.preventDefault(); close(); openCart(); }
    });
    document.addEventListener('keydown', function (e) {
      if (scrim.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(sheet.querySelectorAll('a[href],button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function setUrl(id) {
    try {
      var u = new URL(location.href);
      if (id) u.searchParams.set('note', id); else u.searchParams.delete('note');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function open(id) {
    var n = NOTES[id];
    if (!n) return false;
    ensureShell();
    lastFocus = document.activeElement;
    openId = id;
    unmountBench();
    sheet.innerHTML = noteHTML(id, n, {});
    mountBench();
    scrim.hidden = false;
    document.documentElement.classList.add('fan-open');
    sheet.scrollTop = 0;
    var c = sheet.querySelector('[data-fan-close]');
    if (c) c.focus();
    setUrl(id);
    loadIndex().then(function (by) {
      if (openId !== id || scrim.hidden) return;
      var keepScroll = sheet.scrollTop;
      var focusedClose = document.activeElement && document.activeElement.hasAttribute('data-fan-close');
      unmountBench();
      sheet.innerHTML = noteHTML(id, n, by);
      mountBench();
      sheet.scrollTop = keepScroll;
      if (focusedClose) { var c2 = sheet.querySelector('[data-fan-close]'); if (c2) c2.focus(); }
    });
    return true;
  }

  function close() {
    if (!scrim || scrim.hidden) return;
    scrim.hidden = true;
    openId = null;
    unmountBench();
    document.documentElement.classList.remove('fan-open');
    setUrl(null);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function openCart() {
    var veil = document.getElementById('fcart-veil');
    if (veil && veil.classList.contains('on')) { if (window.__fcartRefresh) window.__fcartRefresh(); return; }
    var icon = document.querySelector('.fh3-cart, .fv3-cart');
    if (icon) icon.click();
    else if (window.__fcartRefresh) window.__fcartRefresh();
  }

  function add(btn) {
    var vid = btn.getAttribute('data-fan-add');
    var msg = btn.closest('.fan-prod').querySelector('.fan-prod__msg');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    msg.className = 'fan-prod__msg';
    msg.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        btn.textContent = 'Added';
        msg.innerHTML = 'In your cart. <a href="/cart" data-fan-cart>View cart</a>';
        if (window.__fcartRefresh) { try { window.__fcartRefresh(); } catch (e) {} }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          [].slice.call(document.querySelectorAll('.fv3-cart .count, .fh3-cart .count')).forEach(function (el) { el.textContent = c.item_count; });
        }).catch(function () {});
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        msg.className = 'fan-prod__msg is-err';
        msg.textContent = 'Could not add to cart. Please try again.';
      });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[data-appnote]');
    if (!a) return;
    if (open(a.getAttribute('data-appnote'))) e.preventDefault();
  });

  function fromUrl() {
    try {
      var id = new URL(location.href).searchParams.get('note');
      if (id && NOTES[id]) open(id);
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhanceCards(); fromUrl(); });
  else { enhanceCards(); fromUrl(); }

  window.FI_APPNOTES = { open: open, close: close, cardHTML: cardHTML, ids: Object.keys(NOTES) };
  try { document.dispatchEvent(new Event('fi-appnotes-ready')); } catch (e) {}
})();
